import { RomEditorState } from 'routes/rom/interfaces';
import { danger, ValidationMapOf } from 'shared/helper-text-helpers';

export function validateRom(state: RomEditorState, mode: 'create' | 'update'): ValidationMapOf<RomEditorState> {
    const ret: ValidationMapOf<RomEditorState> = {};

    if (!state.name) ret.name = danger('Game ROM name required');

    if (mode === 'create') {
        if (!state.gameFile) ret.gameFile = danger('Game ROM zip file upload required');
    }

    try {
        const parsedMetaData = JSON.parse(state.metaData);
        if (typeof parsedMetaData !== 'object' || parsedMetaData === null) {
            ret.metaData = danger('Top-level value must be a JSON object.');
        }
    } catch (e) {
        ret.metaData = danger('Syntax error in JSON');
    }

    return ret;
}
